import { createFileRoute, Link, notFound, Outlet } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { useEffect } from 'react';
import { PacienteHeader } from '@/components/paciente/PacienteHeader';
import { ErrorState } from '@/components/shared/ErrorState';
import { LoadingState } from '@/components/shared/LoadingState';
import { Button } from '@/components/ui';
import { usePaciente } from '@/hooks/usePaciente';
import { usePatientContextStore } from '@/stores/patient-context-store';

export const Route = createFileRoute('/pep-vida/_authed/pacientes/$cdPaciente')({
  component: PacienteDetailPage,
});

function PacienteDetailPage() {
  const { cdPaciente } = Route.useParams();
  const cd = Number(cdPaciente);
  const { data: paciente, isLoading, error, refetch } = usePaciente(cd);
  const setPatient = usePatientContextStore((state) => state.setPatient);

  useEffect(() => {
    if (!paciente) return;
    setPatient({
      cdPaciente: paciente.cd_paciente,
      nome: paciente.ds_paciente,
      status: 'Paciente aberto',
      meta: `Codigo ${paciente.cd_paciente}`,
    });
  }, [paciente, setPatient]);

  if (isLoading) return <LoadingState />;
  if (error) return <ErrorState message={(error as Error).message} onRetry={() => refetch()} />;
  if (!paciente) throw notFound();

  return (
    <div className="mx-auto max-w-7xl space-y-5">
      <Link to="/pep-vida/pacientes">
        <Button variant="ghost" size="sm"><ArrowLeft className="mr-2 h-4 w-4" />Voltar</Button>
      </Link>
      <PacienteHeader paciente={paciente} />
      <Outlet />
    </div>
  );
}
